module.exports = __webpack_public_path__ + "img/ico-memuresort.3407724d.jpg";